import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../../../shared/util/angularEditorConfig";
import { IArquivoItemModel, IItemSolicitacaoTecnicaModel } from "../../../../../models/item-solicitacao-tecnica.model";
import { INotaItemAuditoriaExecucaoModel } from "../../../../../models/nota-item-auditoria-execucao.model";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { SolicitacaoTecnicaService } from "../../../../../services/solicitacao-tecnica.service";
import { MatTableDataSource } from "@angular/material/table";
import { NotaAuditoriaExecucaoService } from "../../../../../services/nota-auditoria-execucao.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { ModalArquivoComponent } from "../../../../../shared/components/modal-arquivo/modal-arquivo.component";
import { ModalCancelarComponent } from "../../../../../shared/components/modal-cancelar/modal-cancelar-component";


@Component({
  selector: "app-modal-incluir-item-nota-auditoria-execucao",
  templateUrl: "./modal-incluir-item-nota-auditoria-execucao.component.html",
  styleUrls: ["./modal-incluir-item-nota-auditoria-execucao.component.scss"],
})
export  class ModalIncluirItemNotaAuditoriaExecucaoComponent implements OnInit, AfterViewInit {
  public model: INotaItemAuditoriaExecucaoModel = {} as INotaItemAuditoriaExecucaoModel;

  public dataSource = new MatTableDataSource<IArquivoItemModel>([]);
  public semDados: boolean = true;
  public submitted: boolean;
  public titulo: string = "";
  public numeroOsa: string = "";
  public nomeResponsavel: string = "";
  public visualizar: boolean;
  public nNotaAuditoriaExecucao: boolean;
  public nrItem: number;
  public numeroConstacacao: number;
  public numeroAuditoriaConstacao: string = "";
  public notaAuditoriaExecucaoId: number;
  public statusDescricao: string = "";
  public avaliacaoDescricao: string = "";
  constructor(
    public matDialog: MatDialog,
    private dialogRef: MatDialogRef<ModalIncluirItemNotaAuditoriaExecucaoComponent>,
    public notaAuditoriaExecucaoService: NotaAuditoriaExecucaoService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.visualizar = data?.visualizar;
    this.titulo = data?.titulo;
    this.notaAuditoriaExecucaoId = data?.notaAuditoriaExecucaoId;
    this.numeroConstacacao = data?.numeroAuditoriaConstacao;

    this.model.id = data?.element?.id;
    this.nNotaAuditoriaExecucao = data?.numeroNotaAuditoria;
    this.numeroOsa = data?.documentoAssociado;
    this.nrItem = data?.element?.numero;
    this.nomeResponsavel = data?.resposavel;
    this.statusDescricao = data?.element?.status?.descricao || "-";
    this.avaliacaoDescricao = data?.element?.statusAvaliacao?.descricao || "-";

  }
  public acceptTypes: string = `
									image/png,
									image/jpeg,
									application/pdf,
									application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
									video/mp4
								`.replace(/\s/g, '');

  maxFileSizeMB: number = 28;

  @ViewChild("myDiv") private angularEditor: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public form = new FormGroup({
    titulo: new FormControl("", Validators.required),
    descricaoConstatacao: new FormControl("", Validators.required),
    descricaoRecomendacao: new FormControl("", Validators.required),
  });


  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "10rem",
    minHeight: "5rem",
    translate: "yes",
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: "",
    defaultFontName: "",
    defaultFontSize: "",
    fonts: [
      { class: "arial", name: "Arial" },
      { class: "times-new-roman", name: "Times New Roman" },
      { class: "calibri", name: "Calibri" },
      { class: "comic-sans-ms", name: "Comic Sans MS" },
    ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    uploadUrl: "v1/image",
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: "top",
    toolbarHiddenButtons: [["bold", "italic"], ["fontSize"]],
  };

  public editorMaxLength = 2000;

  ngAfterViewInit(): void {
    function load(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 2000 && permitirTeclas) {
        e.preventDefault();
      }
    }
    this.angularEditor?.textArea?.nativeElement?.addEventListener(
      "keydown",
      load,
      false
    );
  }

  onEditorChange(content: string, campo: string) {
    if (content.length > this.editorMaxLength) {
      this.form.get(campo)?.setValue(
        content.substring(0, this.editorMaxLength),
        { emitEvent: false }
      );
    }
  }
  ngOnInit(): void {
    if (this.model?.id) {
       this.obterPorId()
    }
    if (this.data?.element) {
      this.form.patchValue({
        titulo: this.data.element.titulo,
        descricaoConstatacao: this.data.element.descricaoConstatacao,
        descricaoRecomendacao: this.data.element.descricaoRecomendacao
      });

      // Popule os anexos se existirem
      if (this.data.element.anexo && this.data.element.anexo.length > 0) {
        this.dataSource.data = this.data.element.anexo;
      }
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor

    if (this.visualizar === true) {
    }
  }
  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "arquivo":
        return item?.nomeArquivo;
      default:
        return item[property];
    }
  };
  public Download(arquivo: IArquivoItemModel) {
    this.notaAuditoriaExecucaoService.downloadAnexo(this.model.id, arquivo.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.toString();
        link.download = arquivo.nomeArquivo;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  public salvar(modalIncluirArquivo?: boolean, isClose?: boolean) {
    this.submitted = true;
    if (this.form.invalid) {
      return
    }
    const dados = {
      id: this.model?.id,
      notaAuditoriaExecucaoId: this.notaAuditoriaExecucaoId,
      titulo: this.form.get("titulo").value,
      descricaoConstatacao: this.form.get("descricaoConstatacao").value,
      descricaoRecomendacao: this.form.get("descricaoRecomendacao").value,
      anexo: this.dataSource?.data
    } as INotaItemAuditoriaExecucaoModel;

    this.notaAuditoriaExecucaoService
      .salvarItem(dados)
      .then((res) => {
        if (res.sucesso) {
          this.model.id = res?.dados?.id;
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          if (isClose) this.dialogRef.close(true);
          if (modalIncluirArquivo) this.modalIncluirArquivo();
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      })
      .finally(() => { });
  }

  public modalIncluirArquivo() {
    if (!this.model?.id) {
      Swal.fire({
        toast: true,
        position: "top-end",
        title: "Atenção",
        icon: "warning",
        text: "Antes, salve as informações!",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.salvar(true);
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = "modal-component-arquivo";
      dialogConfig.width = "45vw";
      dialogConfig.height = 'auto';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        id: this.model?.id,
        numero: this.model?.numero,

      };
      const modal = this.matDialog.open(ModalArquivoComponent, dialogConfig);
      modal.afterClosed().subscribe((data) => {
        if (data) {

        }
        // this.obterPorId()
      });
    }
  }

  public obterPorId(): void {
    if (!this.model?.id || !this.notaAuditoriaExecucaoId) {
      return;
    }

    this.notaAuditoriaExecucaoService
      .obterItemId(this.notaAuditoriaExecucaoId, this.model.id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;

          this.form.patchValue({
            titulo: res.dados.titulo || '',
            descricaoConstatacao: res.dados.descricaoConstatacao || '',
            descricaoRecomendacao: res.dados.descricaoRecomendacao || ''
          });

          this.numeroConstacacao = res.dados.numero ? parseInt(res.dados.numero) : this.numeroConstacacao;

          if (res.dados.anexo && res.dados.anexo.length > 0) {
            this.dataSource.data = res.dados.anexo;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
          } else {
            this.dataSource.data = [];
          }

          console.log('Dados carregados:', res.dados);

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text: err?.mensagem?.descricao || "Erro ao carregar os dados",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }

  public async anexarArquivosItem(e: any) {
    const files = (e.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    const flatListFiles = Array.from(files);

    for (let i = 0; i < flatListFiles.length; i++) {
      const file = flatListFiles[i];

      const tipo = file.type.toUpperCase();
      const sizeMB = Math.trunc(file.size / 1024 / 1024);

      // Validação de tipo (PDF, PNG, JPG, XLSX e/ou MP4)
      if (tipo.includes("PDF") == false
        && tipo.includes("PNG") == false
        && tipo.includes("JPG") == false
        && tipo.includes("JPEG") == false
        && tipo.includes("MP4") == false
        && tipo.includes("EXCEL") == false
        && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
        alert("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4");
        continue;
      }

      // Validação de tamanho específica para MP4
      if (tipo.includes("MP4")) {
        if (sizeMB > 28) {
          alert("Não é permitido videos com mais de 28Mb");
          continue;
        }
      }
      else if (sizeMB > 28) {
        alert("Não é permitido arquivos com mais de 28Mb");
        continue;
      }

      const fileToArray = await this.getBase64(file);
      this.dataSource.data.push({
        id: 0,
        nomeArquivo: file.name,
        arquivo: fileToArray.toString(),
      });
    }

    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text:
            "Ocorreu um erro ao selecionar o arquivo" +
            error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      };
    });
  }

  public cancelar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      interno: true,
      fecharApenasPropria: true
    };

    if (this.visualizar) {
      this.dialogRef.close();
    } else {
      const modalCancelar = this.matDialog.open(ModalCancelarComponent, dialogConfig);

      modalCancelar.afterClosed().subscribe((confirmado) => {
        if (confirmado === true) {
          this.dialogRef.close(false); // fecha apenas a modal do item
        }
      });
    }
  }
  public excluirArquivo(id: number) {
    Swal.fire({
      title: "Excluir Registro",
      text: "Tem certeza que deseja excluir esse Registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.notaAuditoriaExecucaoService
          .excluirAnexo(this.notaAuditoriaExecucaoId, this.model?.id, id)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              text: err.mensagem.descricao,
              icon: "error",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
            this.obterPorId();
          });
      }
    });
  }
}
